import {Database} from 'utils/db/tables.generated'
import {z} from 'zod'
import {zRoles} from 'shared/forecast/roleTypes'

export const zInviteNew = z.object({
  email: z.string().default(''),
  roles: z.array(zRoles).default(['forecaster'])
})
export type InviteNew = z.infer<typeof zInviteNew>
export const emptyInvite = () => zInviteNew.parse({})

const enumStatus = [
  'pending',
  'sending',
  'sent',
  'authenticated',
  'profile',
  'expired',
  'canceled',
  'error',
  'removed'
] as const
export type InviteStatus = (typeof enumStatus)[number]

export const zInvite = zInviteNew.extend({
  id: z.string(),
  workspace_id: z.string(),
  roles: z.array(zRoles).min(1, {message: 'invites need at least one role'}).default(['forecaster']),
  status: z.enum(enumStatus).default('sent'),
  status_msg: z.preprocess(z => z ?? undefined, z.string().optional()),
  created_at: z.coerce.date(),
  email: z.string().toLowerCase().trim().email(),
  cfg: z.object({token: z.string().optional()}).nullish()
})
export type Invite = z.infer<typeof zInvite>

export type InviteTable = Database['public']['Tables']['invite']
export type InviteRowInsert = InviteTable['Insert']
